import App from "App";
import { LayoutName } from "components/context/LayoutContext";
import AppNavigation from "components/shared/AppNavigation";
import React from "react";
import * as Styled from "./styled";

interface Props {
  children: React.ReactNode;
  layoutName?: LayoutName;
  hideNavigation?: boolean;
  routeParent?: any;
}

const AppLayout: React.FC<Props> = ({
  children,
  layoutName,
  routeParent,
  hideNavigation,
}) => {
  return (
    <App layoutName={layoutName}>
      <Styled.AppWrapper
        $hideNavigation={hideNavigation}
        style={{
          viewTransitionName: routeParent ? "route-child" : "route-parent",
        }}
      >
        <Styled.GlobalStyles />

        {!hideNavigation && (
          <Styled.NavWrapper>
            <AppNavigation />
          </Styled.NavWrapper>
        )}

        <Styled.MainWrapper>
          <Styled.ContentWrapper>{children}</Styled.ContentWrapper>
        </Styled.MainWrapper>
      </Styled.AppWrapper>
    </App>
  );
};

export default AppLayout;
